import React from "react";
export default class OtherInningsDetails extends React.Component {
  render() {
    let didntbat = this.props.did_not_bat;
    let fows = this.props.fows;
    // console.log(this.props);

    return (
      <div>
        <div className="other_summmry_match_wrapp">
          {didntbat && didntbat.length > 0 ? (
            <div className="other_summmry_match">
              <h5 className="gray_14_semibold">{this.props.res.status_str == 'Live' && this.props.res.innings.length - 1 == this.props.index ? 'Yet to Bat' : 'Did not bat'}</h5>
              <div className="did_not_bat">
                <h6 className="batsmen_name">
                  {didntbat.map((didntbat, index) => {
                    return index == 0 ? didntbat.name : ", " + didntbat.name;
                  })}
                </h6>
              </div>
            </div>
          ) : (
              ""
            )}
          {fows && fows.length > 0 ? (
            <div className="other_summmry_match">
              <h5 className="gray_14_semibold">Fall of wickets</h5>
              <div className="did_not_bat">
                <h6 className="batsmen_name">
                  {fows.map((fowsdata, index) => {
                    return (
                      index == 0 ?
                        <span>
                          <span>
                            {" " + fowsdata.number}-
                          {fowsdata.score_at_dismissal + " "}
                          </span>
                          <span className="fall_wickets_name">
                            ({" " + fowsdata.name}{", "}
                            {fowsdata.overs_at_dismissal + " ov "} )
                        </span>
                        </span> :

                        <span>
                          <span>
                            {", " + fowsdata.number}-
                        {fowsdata.score_at_dismissal + " "}
                          </span>
                          <span className="fall_wickets_name">
                            ({" " + fowsdata.name}{", "}
                            {fowsdata.overs_at_dismissal + " ov "} )
                      </span>
                        </span>
                    );
                  })}

                  {/* 1-67{" "}
                <span className="fall_wickets_name">(S Dhawan, 7.5 ov)</span>,
                2-115{" "}
                <span className="fall_wickets_name">(RG Sharma, 13.5 ov)</span>,
                3-126{" "}
                <span className="fall_wickets_name">(RR Pant, 15.1 ov)</span>,
                4-132{" "}
                <span className="fall_wickets_name">(V Kohli, 16.2 ov)</span>,
                5-143{" "}
                <span className="fall_wickets_name">(M Pandey, 18.3 ov)</span> */}
                </h6>
              </div>
            </div>
          ) : (
              ""
            )}
        </div>
      </div>
    );
  }
}
